import stringify from 'fast-json-stable-stringify';

export function stableStringify(obj: any) {
  return stringify(obj);
}

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Cyclic_object_value#examples
export function safeStringifyCircular(obj: any): string {
  function getCircularReplacer() {
    const ancestors = [] as any[];
    return function(key, value) {
      if (typeof value !== 'object' || value === null) {
        return value;
      }
      // `this` is the object that value is contained in,
      // i.e., its direct parent.
      // @ts-expect-error
      while (ancestors.length > 0 && ancestors.at(-1) !== this) {
        ancestors.pop();
      }
      if (ancestors.includes(value)) {
        return '[Circular]';
      }
      ancestors.push(value);
      return value;
    };
  }
  return JSON.stringify(obj, getCircularReplacer());
}
